import { PageHeader } from "../components/PageHeader";
import { useSiteContent } from "../context/ContentContext";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import Icon from "../components/Icon";

export default function Services() {
  const { content } = useSiteContent();
  const { services, process, services_page } = content;
  const pageCopy = services_page || {};
  return (
    <>
      <PageHeader
        eyebrow={pageCopy.header_eyebrow}
        title={
          <>
            {pageCopy.header_title_part1}{" "}
            <span className="theme-text-accent">{pageCopy.header_title_highlight}</span>{" "}
            {pageCopy.header_title_part2}
          </>
        }
        intro={pageCopy.header_intro}
      />

      <section className="section-pad">
        <div className="container-x grid grid-cols-1 sm:grid-cols-2 md:[grid-template-columns:repeat(auto-fit,minmax(260px,1fr))] gap-6">
          {services.map((s, i) => (
            <motion.div key={s.key || i} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.05 }} className="card-soft p-8" data-testid={`service-${s.key}`}>
              <div className="w-14 h-14 rounded-2xl theme-icon-chip flex items-center justify-center mb-6">
                <Icon name={s.icon} className="w-6 h-6" />
              </div>
              <h3 className="font-display text-2xl font-bold theme-text-primary mb-3">{s.title}</h3>
              <p className="theme-text-secondary text-sm leading-relaxed">{s.short}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="theme-bg-secondary section-pad" data-testid="process-section">
        <div className="container-x">
          <div className="eyebrow mb-4">{pageCopy.process_eyebrow}</div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold theme-text-primary mb-10 sm:mb-14 tracking-tight max-w-3xl">
            {pageCopy.process_title_part1}{" "}
            <span className="theme-text-accent">{pageCopy.process_title_highlight}</span>
            {pageCopy.process_title_part2}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:[grid-template-columns:repeat(auto-fit,minmax(220px,1fr))] gap-5">
            {process.map((p, i) => (
              <motion.div key={p.n || i} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.04 }} className="theme-surface rounded-2xl p-6"
                data-testid={`process-step-${p.n}`}>
                <div className="font-display text-3xl font-bold theme-text-accent mb-4">{p.n}</div>
                <h3 className="font-display text-xl font-bold theme-text-primary">{p.title}</h3>
                <p className="theme-text-secondary text-sm leading-relaxed mt-2">{p.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-x">
          <div className="rounded-3xl theme-gradient-dark p-7 sm:p-10 md:p-16 flex flex-col md:flex-row items-center justify-between gap-6">
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold max-w-2xl">
              {pageCopy.cta_title}
            </h2>
            <Link to="/contact" className="btn-primary w-full sm:w-auto justify-center">
              {pageCopy.cta_button} <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
